import { getApiPathFromUrl } from '@nike/ux-tread-dotcom-utils';
import getErrorCode from './get-error-code';

/**
 * @memberof ux-tread-crc-code
 * Given a full api url or path, and code, status or message based on Nike API standards
 * this function retrieves a unique crc code to leverage for telemetry, visibility for users calling prod support
 * and providing better error messaging without conflating error messages meant for internal use
 * @param {object} params - named parameters for clarity
 * @property {string} params.url - full url used in an api call
 * @property {string} params.path - a Nike standard api path containing domain/resource/version
 * @property {number|string} params.status - response status codes per REST guidelines @see {@link https://en.wikipedia.org/wiki/List_of_HTTP_status_codes | HTTP Status Codes}
 * @property {string} params.code - error code in body of error response following Nike API standard error patterns @see {@link https://confluence.nike.com/display/NEA/API+-+Error+Patterns | Nike API Error Patterns}
 * @property {string} params.message - error message in body of error response following Nike API standard error patterns @see {@link https://confluence.nike.com/display/NEA/API+-+Error+Patterns | Nike API Error Patterns}
 * @returns {string} a unique error code specific to {domain}/{resource}/{version}/{code|status|message}
 */
export default function getCrcCode(_ref) {
  var url = _ref.url,
    path = _ref.path,
    status = _ref.status,
    code = _ref.code,
    message = _ref.message;
  var apiPath;
  if (path) {
    apiPath = path.replace(/^\//, '').replace(/[/?]$/, '');
  }
  if (url) {
    apiPath = getApiPathFromUrl(url);
  }
  return getErrorCode("/".concat(apiPath, "/"), code || status || message);
}